// Phase 10f-1 — operator refund admin read schemas (list + detail).
// Read-only surface; refund issuance shipped at 10d-i-c via
// POST /admin/payment-events/refund (operator-payment-admin.schema.ts).
import { z } from 'zod';
import { BuyerTypeSchema, InvoiceStatusSchema } from './enums.schema.js';
/** Refund kind reflected in the list row — distinguishes Stripe-originated
 * refunds (homecare) from operator-recorded negative MANUAL_CREDIT events
 * (facility cheque-written-back). Both are surfaced by 10f-1. */
export const RefundKindSchema = z.enum(['STRIPE_REFUND', 'MANUAL_CREDIT_NEGATIVE']);
export const RefundListQuerySchema = z.object({
    fromDate: z.string().date().optional(),
    toDate: z.string().date().optional(),
    buyerType: BuyerTypeSchema.optional(),
    page: z.coerce.number().int().min(1).default(1),
    limit: z.coerce.number().int().min(1).max(200).default(50),
});
export const RefundListItemSchema = z.object({
    id: z.string().uuid(),
    kind: RefundKindSchema,
    buyerType: BuyerTypeSchema,
    partyName: z.string(),
    invoiceId: z.string().uuid(),
    invoiceNumber: z.string().nullable(),
    amountCents: z.number().int().nonnegative(),
    externalRef: z.string().nullable(),
    reason: z.string().nullable(),
    issuedAt: z.string().datetime(),
    issuedByUserId: z.string().uuid().nullable(),
});
export const RefundListResponseSchema = z.object({
    items: z.array(RefundListItemSchema),
    page: z.number().int().min(1),
    limit: z.number().int().min(1),
    totalCount: z.number().int().min(0),
});
const InvoiceSummarySchema = z.object({
    id: z.string().uuid(),
    invoiceNumber: z.string().nullable(),
    buyerType: BuyerTypeSchema,
    status: InvoiceStatusSchema,
    totalCents: z.number().int().nonnegative(),
    amountPaidCents: z.number().int(),
});
const OriginatingEventSchema = z.object({
    id: z.string().uuid(),
    eventType: z.string(),
    amountCents: z.number().int(),
    externalRef: z.string().nullable(),
    recordedAt: z.string().datetime(),
});
const AuditEventSummarySchema = z.object({
    id: z.string().uuid(),
    action: z.string(),
    actorUserId: z.string().uuid().nullable(),
    createdAt: z.string().datetime(),
});
export const RefundDetailResponseSchema = z.object({
    refund: RefundListItemSchema,
    invoice: InvoiceSummarySchema,
    /** Originating PaymentEvent (STRIPE_CAPTURE for STRIPE_REFUND kind;
     * positive MANUAL_CREDIT/CHEQUE/EFT for MANUAL_CREDIT_NEGATIVE kind).
     * Null when not resolvable (orphan refund — flagged via `orphaned`). */
    originatingPaymentEvent: OriginatingEventSchema.nullable(),
    orphaned: z.boolean(),
    auditTrail: z.array(AuditEventSummarySchema),
});
//# sourceMappingURL=refund-admin.schema.js.map